import Link from 'next/link';
import { IoMdHeart } from 'react-icons/io';

import styles from './FavoritesAside.module.scss';

export default function FavoriteAside() {
  const tooltip =
    'Δες τη λίστα με τα αγαπημένα σου και τις έξυπνες προτάσεις προϊόντων που ψωνίζεις συχνά, για ακόμα πιο εύκολες και γρήγορες αγορές!';
  return (
    <Link href="/favorites">
      <a className={styles.favoriteLink} title={tooltip}>
        <div className={styles.container}>
          <IoMdHeart className={styles.favoriteIcon}/>
          <span>Αγαπημένα</span>
        </div>
      </a>
    </Link>
  );
}
